// Custom
export { default as UiIconShadeDark } from './custom/shade-dark.svg';
export { default as UiIconShadeLight } from './custom/shade-light.svg';
export { default as UiIconShadeNormal } from './custom/shade-normal.svg';
export { default as UiIconTemplateEmpty } from './custom/empty-template.svg';
export { default as UiIconTemplateFilled } from './custom/filled-template.svg';

// File-type
export { default as FormatPdf } from './file-type/format-pdf.svg';
export { default as ImageDocument } from './file-type/image-document.svg';
export { default as LinkedFile } from './file-type/linked-file.svg';
export { default as RegularDocument } from './file-type/regular-document.svg';
export { default as StatisticDocument } from './file-type/statistic-document.svg';
export { default as TypeFolder } from './file-type/type-folder.svg';
export { default as TypeMail } from './file-type/type-mail.svg';
export { default as VideoFile } from './file-type/video-file.svg';

// Editor
export { default as UiIconBold } from './editor/bold.svg';
export { default as UiIconItalic } from './editor/italic.svg';
export { default as UiIconOl } from './editor/ol.svg';
export { default as UiIconParagraph } from './editor/paragraph.svg';
export { default as UiIconRedo } from './editor/redo.svg';
export { default as UiIconUl } from './editor/ul.svg';
export { default as UiIconUndo } from './editor/undo.svg';

// Illustrations
export { default as IllustrationCloudSearch } from './illustrations/cloud-search.svg';
export { default as IllustrationUploadDocument } from './illustrations/upload-document.svg';
